<app-sync-banner
    *ngIf="isSyncNeeded"
    [workflowArea]="WorkflowArea.CLOSING_PROCESS"
    (dismiss)="onDismiss()"
    (sync)="onSync()"
></app-sync-banner>
<workflow-form
    *ngIf="tasks$ | async as tasks"
    [tasks]="tasks"
    [area]="WorkflowArea.CLOSING_PROCESS"
    [assigneeOptions]="assigneeOptions"
    (updateTask)="updateTask($event)"
    (bulkUpdateTasks)="bulkUpdateTasks($event)"
    (addTask)="addNewTask($event)"
    (deleteTask)="deleteTask($event)"
    [annotationsMap]="annotationsMap"
    [documentsMap]="documentsMap"
    [documentsInProgressUpload]="documentsInProgressUpload"
    [currentUserId]="activeUserAumicoInternalId"
    [projectId]="projectId"
    (annotationAdded)="onAnnotationAdded($event)"
    (annotationChanged)="onAnnotationChanged($event)"
    (annotationRemoved)="onAnnotationRemoved($event)"
    (documentsAdded)="onDocumentsAdded($event)"
    (documentRemoved)="onDocumentRemoved($event)"
    (documentsAddedInProgress)="onDocumentsAddedInProgress($event)"
    (exportZip)="exportZip($event)"
    (exportExcel)="exportTasksExcel($event)"
    (syncWorkflow)="onSync()"
    (openFile)="onOpenFile($event)"
    (downloadFile)="onDownloadFile($event.fileId, $event.documentName)"
    (stopPolling)="onStopPolling($event)"
    (startPolling)="onStartPolling($event)"
    [selectAll]="selectAll"
    [sectionToggled]="sectionToggled"
    [selectedTaskIds]="selectedTaskIds"
    (toggleSelectAll)="toggleCheckAll($event)"
    (toggleSelectSection)="toggleSectionSelectAll($event)"
    (toggleSelectTask)="toggleCheckTask($event)"
    (selectedTabChanged)="onSelectedTabChanged($event)"
></workflow-form>
<app-loading-spinner [active]="isSyncingWorkflow"></app-loading-spinner>
<!-- Bulk Edit action bar -->
<bulk-edit-action-bar
    *ngIf="selectedTaskIds?.size > 0"
    [selectedCount]="selectedTaskIds?.size"
    [actions]="bulkActions"
    [deleteAction]="deleteAction"
    textSelectedTranslationKey="aumico_companies_bulk_edit_action_bar_selected_text"
    [globalPosition]="true"
    (actionClicked)="onActionClicked($event)"
></bulk-edit-action-bar>

<!-- Ham Modal for Bulk Edit Status -->
<ham-modal
    *ngIf="openBulkEditStatus"
    [title]="'aumico_tasks_overview_bulk_edit_status_title' | i18next : { count: selectedTaskIds.size }"
    [cancelText]="'aumico_button_cancel' | i18next"
    [showCancelButton]="true"
    (cancel)="openBulkEditStatus = false"
    [saveText]="'aumico_button_save' | i18next"
    (save)="onEditStatusConfirm()"
    ><input
        hamSimpleDropDown
        [label]="'aumico_tasks_overview_bulk_edit_status_label' | i18next"
        [options]="possibleStatus"
        [optionKeys]="['name']"
        returnKey="id"
        [returnObject]="true"
        [placeholder]="'aumico_tasks_overview_bulk_edit_status_placeholder' | i18next"
        [formControl]="bulkEditStatusControl"
/></ham-modal>

<!-- HamModal for Bulk Delete -->
<ham-confirm-decline-modal
    *ngIf="openBulkDeleteConfirmationDialog"
    (cancel)="cancelDeleteBulkTasks()"
    (action)="confirmDeleteBulkTasks()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_button_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_button_cancel' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="'aumico_app_cpmm_tasks_delete_confirmation' | i18next : { count: selectedTaskIds.size }"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>
